import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.veranstaltung-info-kategorie-entfernen';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenVeranstaltungInfoKategorieEntfernenEffects {

    VeranstaltungInfoKategorieEntfernen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_VERANSTALTUNG_INFO_KATEGORIE_ENTFERNEN),
        mergeMap((x: ac.PostVeranstaltungInfoKategorieEntfernenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postVeranstaltungInfoKategorieEntfernen(x.infoKategorieRequest).pipe(
                map((result: any) => {
                    return new ac.PostVeranstaltungInfoKategorieEntfernenErfolgreichAction(result, x.infoKategorieRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostVeranstaltungInfoKategorieEntfernenFehlerAction(error, x.infoKategorieRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AdminCommandService);
        }
        return this.service;
    }
}
